"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => ({
    root: {
        height: 22,
        verticalAlign: 'top',
        '&:before': {
            border: 0,
        },
    },
    input: {
        padding: '2pt',
    },
    disabled: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    chips: {
        marginTop: 3,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    chip: {
        height: 20,
    },
    inputWrapper: {
        flexGrow: 1,
        flexShrink: 1,
        minWidth: '30%',
    },
    wrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.editing,
    },
    wrapperDisabled: {
        backgroundColor: 'inherit',
    },
}));
//# sourceMappingURL=text-field-multiple-styles.js.map